import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { loginRequest, useAuth } from "@/lib/auth";
import { ADMIN } from "@/constants/testIds";
import { Lightning, Eye, EyeSlash } from "@phosphor-icons/react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState("admin@vapeessence.co.za");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const res = await loginRequest(email, password);
      if (res.role !== "admin") {
        setErr("Not an admin account");
        setLoading(false);
        return;
      }
      await refresh();
      toast.success("Welcome, admin");
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-[440px] flex-col justify-center px-6 py-16 lg:px-10">
      <div className="mb-8 flex items-center gap-3">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-[#FF5A1F] ring-neon">
          <Lightning size={20} weight="fill" color="#050505" />
        </span>
        <div>
          <div className="font-label text-xs text-[#FF5A1F]">/ ADMIN</div>
          <div className="font-display text-2xl font-black tracking-tighter">Vape Essence</div>
        </div>
      </div>

      <form onSubmit={submit} className="border border-white/10 bg-[#0d0d0d] p-8 space-y-4">
        <input
          data-testid={ADMIN.loginEmail}
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-white/15 bg-black px-4 py-3 text-sm outline-none focus:border-[#FF5A1F]"
        />
        <div className="relative">
          <input
            data-testid={ADMIN.loginPassword}
            type={showPassword ? "text" : "password"}
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-white/15 bg-black px-4 py-3 pr-11 text-sm outline-none focus:border-[#FF5A1F]"
          />
          <button
            type="button"
            data-testid="admin-login-toggle-password"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            className="absolute inset-y-0 right-2 flex items-center justify-center px-2 text-white/60 hover:text-[#FF5A1F]"
          >
            {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
          </button>
        </div>
        {err && <div className="text-xs text-[#FF5A1F]">{err}</div>}
        <button
          data-testid={ADMIN.loginSubmit}
          disabled={loading}
          className="w-full bg-[#00FFC2] py-3 font-label text-xs text-black hover:-translate-y-0.5 transition-transform disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign in to admin"}
        </button>
      </form>
    </div>
  );
}
